import React from 'react';
import ReactDOM from 'react-dom';

import type { Initializer } from 'common/types/initializers';
import { Reconnect } from 'src/federation/Reconnect';

import type { SharedProps } from 'reconnect-types/moduleFederation';

type FooterProps = Pick<
  SharedProps['ClientListFooter'],
  | 'totalCustomers'
  | 'filterResultCount'
  | 'canSendEmail'
  | 'canExport'
  | 'canCreateClients'
  | 'canImportClients'
  | 'canBulkDelete'
  | 'onSendEmail'
  | 'onExport'
  | 'onUseTemplate'
  | 'onBulkDelete'
  | 'onResetFilters'
>;

type Props = {
  node: HTMLElement;
};

export const ClientListFooterInitializer = ({ node }: Props): Initializer => {
  const destroy = () => ReactDOM.unmountComponentAtNode(node);

  return {
    destroy,
    // Re-invoked from the Backbone view whenever the count / permission props
    // change; ReactDOM.render reconciles the same node with the fresh props.
    render: (props: FooterProps) => {
      ReactDOM.render(<Reconnect name="ClientListFooter" props={props} />, node);
    },
  };
};
